<template>

  <v-container fluid class="page page-shipper-list">

    <!-- Breadcrumb & Actions -->
    <v-row class="mt-3 mb-6">
      <v-col sm="8" class="d-flex align-center justify-start page-breadcrumb-new">
        <!-- (breadcrumb) -->
        <v-icon small class="mr-2">mdi-truck</v-icon>
        <div>Shipper Locations</div>
      </v-col>
      <v-col sm="4" align="right">
      </v-col>
    </v-row>

    <!-- Sys-Admin Notifications -->
    <location-sys-admin-notifications
        class="mb-5"
        locationType="shipper"
        v-if="uiType === 'sys-admin'" />

    <!-- Shipper Location List -->
    <shipper-location-list-data-table />

  </v-container>

</template>

<script>
import LocationSysAdminNotifications from '@/components/locations/LocationSysAdminNotifications'
import ShipperLocationListDataTable from '@/components/shipperLocations/ShipperLocationListDataTable'

export default {
  name: 'ShipperListPage',

  components: {
    LocationSysAdminNotifications,
    ShipperLocationListDataTable
  },

  computed: {
    uiType () {
      return this.$root.uiType()
    }
  }
}
</script>

<style scoped>
</style>
